var codeblock_default = {
  "blockStyleSpacing": "OI86J",
  "codeBlock": "DBtgg OI86J",
  "renderedInTable": "q4nxs"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
